"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (date) {
    return new Date(date - date.getTimezoneOffset() * 60 * 1000).toISOString();
};


//////////////////
// WEBPACK FOOTER
// ./~/binary-utils/lib/date/dateAsLocalISOString.js
// module id = 8
// module chunks = 0